module.exports = __webpack_public_path__ + "media/sound2.902e6a0b.wav";